export default "__VITE_ASSET__C60Bd862__"